import setters from './setters';

export default { ...setters };
